import { render, staticRenderFns } from "./subAreaBuild2.vue?vue&type=template&id=1ece091b&scoped=true&"
import script from "./subAreaBuild2.vue?vue&type=script&lang=js&"
export * from "./subAreaBuild2.vue?vue&type=script&lang=js&"
import style0 from "./subAreaBuild2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./subAreaBuild2.vue?vue&type=style&index=1&id=1ece091b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ece091b",
  null
  
)

export default component.exports